import { FondsDetail } from './FondsDetail/FondsDetail';

const fondsDetail = document.getElementById('fondsdetails');
if (fondsDetail) {
  new FondsDetail(fondsDetail);
}